export const InsertSupplierProduct = async (dataJson: any) => {
    const respone = await fetch("api/SupplierEcatalog/InsertSupplierProduct", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };
  export const UpdateSupplierProduct = async (dataJson: any) => {
    const respone = await fetch("api/SupplierEcatalog/UpdateSupplierProduct", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };
  export const GetSupplierProduct = async (dataJson: any) => {
    const respone = await fetch("api/SupplierEcatalog/GetSupplierProduct", {

      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };
  export const UploadImage = async (FormFile: any,
    RowID: number,
    CreatedBy: string,
    ModifiedBy: string
) => {


    const formData = new FormData();
    //formData.append('model', model);
    FormFile.map((file : any) => {
        formData.append('ImageFile', file.originFileObj);
    })
    
    formData.append('RowID', RowID.toString());
    formData.append('CreatedBy', CreatedBy);
    formData.append('ModifiedBy', ModifiedBy);
    const respone = await fetch("api/SupplierEcatalog/UploadImage", {
        method: "POST",
        headers: {
            'Accept': '*/*',
            //"Content-Type": "multipart/form-data",
        },

        body: formData,//JSON.stringify(jsonData),
    })
        .then((response) => response.json())
        .then((data) => {
            return data;
        })
        .catch((err) => { 
            console.log("uploadfile", err);

        });
    return respone;
}; 

export const GetSupplierProductImage = async (dataJson: any) => {
    const respone = await fetch("api/SupplierEcatalog/GetSupplierProductImage", {

      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const ImportProduct = async (dataJson: any) => {
    const respone = await fetch("api/SupplierEcatalog/ImportProduct", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const RemoveImage = async (dataJson: any) => {
    const respone = await fetch("api/SupplierEcatalog/RemoveImage", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  export const GetMasterProductImage = async (dataJson: any) => {
    const respone = await fetch("api/SupplierEcatalog/GetMasterProductImage", {

      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };

  
  